import { EISelectBox } from 'components/customComponents/Layers/EICheckBox';
import React from 'react';
import { SaveProfileTuningValuesDTO } from 'business/models/Models';
import { LevelingOptions, LimitOptions, levelingOptions } from '../constants';
import { CaptureProfileType } from '../types';
import InputWithToggleLabel from 'components/input/inputWithToggleLabel';

interface ImageTuningPanelProps {
  setEnableHeaderButtons: React.Dispatch<React.SetStateAction<boolean>>;
  selectedCps: Array<number>;
  selectedRows: Array<number>;
  cpData: CaptureProfileType;
  setCpData: React.Dispatch<React.SetStateAction<CaptureProfileType>>;
  tuningFieldError?: string;
  setTuningFieldError?: React.Dispatch<React.SetStateAction<string>>;
}

const ImageTuningPanel = (props: ImageTuningPanelProps) => {
  const {
    setEnableHeaderButtons,
    selectedCps,
    cpData,
    setCpData,
    tuningFieldError,
    setTuningFieldError,
  } = props;

  const getLevelingMode = () => {
    const tuningValues = cpData[selectedCps[0]]?.tuningValuesDTOs[0];
    if (tuningValues) {
      if (tuningValues.autoLevelingOn === true) {
        return LevelingOptions.Auto;
      } else if (
        tuningValues.lowerLevelLimit === 0 &&
        tuningValues.upperLevelLimit === 255
      ) {
        return LevelingOptions.Off;
      } else {
        return LevelingOptions.Manual;
      }
    }
    return null;
  };

  const changeLevelingMode = (e) => {
    const val = Number(e.target.value);

    const newData = { ...cpData };
    const newTuningValues = new SaveProfileTuningValuesDTO();
    Object.assign(newTuningValues, newData[selectedCps[0]].tuningValuesDTOs[0]);

    if (val === LevelingOptions.Off) {
      newTuningValues.lowerLevelLimit = 0;
      newTuningValues.upperLevelLimit = 255;
      newTuningValues.autoLevelingOn = false;
    } else if (val === LevelingOptions.Manual) {
      newTuningValues.lowerLevelLimit = 1;
      newTuningValues.upperLevelLimit = 255;
      newTuningValues.autoLevelingOn = false;
    } else if (val === LevelingOptions.Auto) {
      newTuningValues.lowerLevelLimit = 0;
      newTuningValues.upperLevelLimit = 255;
      newTuningValues.autoLevelingOn = true;
    }

    Object.assign(newData[selectedCps[0]].tuningValuesDTOs[0], newTuningValues);

    setCpData(newData);
    setEnableHeaderButtons(true);
  };

  const onLimitChange = (e, limitOption: LimitOptions) => {
    const newData = { ...cpData };
    const newTuningValues = new SaveProfileTuningValuesDTO();
    Object.assign(newTuningValues, newData[selectedCps[0]].tuningValuesDTOs[0]);

    if (limitOption === LimitOptions.lowerLevelLimit) {
      let lowerLevel = parseInt(e.target.value);
      if (lowerLevel < 0 || lowerLevel > 255) {
        lowerLevel = 0; // default lower limit
      }
      if (lowerLevel >= newTuningValues.upperLevelLimit) {
        setTuningFieldError('Lower level limit should be lesser than upper level limit');
      } else {
        setTuningFieldError(undefined);
      }
      newTuningValues.lowerLevelLimit = lowerLevel;
    } else if ((limitOption = LimitOptions.upperLevelLimit)) {
      let upperLevel = parseInt(e.target.value);
      if (upperLevel < 0 || upperLevel > 255) {
        upperLevel = 255; // default upper limit
      }
      if (upperLevel <= newTuningValues.lowerLevelLimit) {
        setTuningFieldError('Upper level limit should be greater than lower level limit');
      } else {
        setTuningFieldError(undefined);
      }
      newTuningValues.upperLevelLimit = upperLevel;
    }

    Object.assign(newData[selectedCps[0]].tuningValuesDTOs[0], newTuningValues);
    setCpData(newData);
    setEnableHeaderButtons(true);
  };
  return (
    selectedCps.length > 0 && (
      <div id="imagetuningpanel-wrapper" className="w-full p-2">
        <div id="imagetuningpanel-title" className={'image-tuning-heading'}>
          Image Tuning
        </div>
        <div
          id="imagetuningpanel-levelingmode-wrapper"
          className="d-flex flex-row w-100 justify-content-between"
        >
          <div
            id="imagetuningpanel-levelingmode-title"
            className={'image-tuning-heading w-90'}
          >
            Leveling Mode
          </div>
          <div id="imagetuningpanel-levelingmode-selectbox" className="w-6/12">
            <EISelectBox
              labelText=""
              selectedValue={getLevelingMode()}
              onChange={changeLevelingMode}
              options={levelingOptions}
            />
          </div>
        </div>
        <div
          id="imagingtuningpanel-manualleveling-wrapper"
          className="d-flex flex-column w-100"
        >
          <div
            id="imagingtuningpanel-manualleveling-title"
            className={'image-tuning-heading'}
          >
            Manual Leveling
          </div>
          <div
            id="imagingtuningpanel-manualleveling-input-wrapper"
            className="d-flex flex-row justify-between	"
          >
            <div
              id="imagingtuningpanel-manualleveling-input-lowerlevellimit"
              className="d-flex flex-row items-center	"
            >
              <InputWithToggleLabel
                label="Lower Level Limit"
                type="number"
                value={cpData[selectedCps[0]]?.tuningValuesDTOs[0]?.lowerLevelLimit}
                handleChange={(e) => {
                  onLimitChange(e, LimitOptions.lowerLevelLimit);
                }}
                min={0}
                max={255}
                disabled={getLevelingMode() !== LevelingOptions.Manual}
                error={tuningFieldError}
              />
            </div>
            <div
              id="imagingtuningpanel-manualleveling-input-upperlevellimit"
              className="d-flex flex-row items-center	"
            >
              <InputWithToggleLabel
                label="Upper Level Limit"
                type="number"
                value={cpData[selectedCps[0]]?.tuningValuesDTOs[0]?.upperLevelLimit}
                handleChange={(e) => {
                  onLimitChange(e, LimitOptions.upperLevelLimit);
                }}
                min={0}
                max={255}
                disabled={getLevelingMode() !== LevelingOptions.Manual}
                error={tuningFieldError}
              />
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default ImageTuningPanel;
